<div>
    <div class="page-padding" >
        <!-- <div class="center" *ngIf="equipmentDetails == null  ">
          <mat-spinner></mat-spinner>
        </div> -->
        <div class="panel" *ngIf="equipmentDetails != null" [@enterAnimation]>
          <div class="panel__header">
            <span class="panel__header__title">
              {{ Translate('Equipment Details') }}
            </span>
          </div>
          <div class="panel__content flex flex--align-center">
            <div class="overall-eval-container">
              <img [src]="getImage(equipmentDetails.EquipmentPhoto)" class="equipment-photo" />
              <div class="bold font-size--xl margin-r--24 Eval-{{equipmentDetails.PercentWorn | wornPercentageToEval }}">
                {{equipmentDetails.PercentWorn | number:'1.0-1'}}%
              </div>
            </div>
            <div class="column-container flex-grow">
              <div class="column-container__column">
                <div class="text-block">
                  <span class="text-block__label">
                    {{ Translate('Customer') }}
                  </span>
                  <span class="text-block__important">
                    {{equipmentDetails.CustomerName}}
                  </span>
                </div>
                <div class="text-block">
                  <span class="text-block__label">
                    {{ Translate('Job Site') }}
                  </span>
                  <span class="text-block__important">
                    {{equipmentDetails.JobsiteName}}
                  </span>
                </div>
              </div>
              <div class="column-container__column">
                <div class="text-block">
                  <span class="text-block__label">  
                    {{ Translate('Serial Number') }}
                  </span>
                  <span class="text-block__important"><a routerLink="/equipment/{{equipmentId}}"
                   >
                    {{equipmentDetails.SerialNumber}}</a>
                  </span>
                </div>
                <div class="text-block">
                  <span class="text-block__label">
                    {{ Translate('Unit Number') }}
                  </span>
                  <span class="text-block__important"><a routerLink="/equipment/{{equipmentId}}"
                  >
                    {{equipmentDetails.UnitNumber}}</a>
                  </span>
                </div>

                <div class="text-block"  *ngIf="equipmentDetails.AdditionalUnitNo!=null">
                  <span class="text-block__label">
                    {{ Translate('Additional Unit Number') }}
                  </span>
                  <span class="text-block__important">
                    {{equipmentDetails.AdditionalUnitNo}}
                  </span>
                </div>
              </div>
              <div class="column-container__column">
                <div class="text-block">
                  <span class="text-block__label">
                    {{ Translate('Last Inspection Date') }}
                  </span>
                  <span class="text-block__important">
                    {{equipmentDetails.LastInspectionDate}}
                  </span>
                </div>
                <div class="text-block">
                  <span class="text-block__label">
                    {{ Translate('Next Inspection Date') }}
                  </span>
                  <span class="text-block__important">
                    {{ equipmentDetails.NextInspectionDate }}
                  </span>
                </div>
              </div>
              <div class="column-container__column">
                <div class="text-block">
                  <span class="text-block__label">
                    {{ Translate('Meter Reading (SMU/HourMeter)') }}
                  </span>
                  <span class="text-block__important">
                    {{equipmentDetails.Smu}}
                  </span>
                </div>
                <div class="text-block">
                  <span class="text-block__label">
                    {{ Translate('Life to Date (LTD)') }}
                  </span>
                  <span class="text-block__important">
                    {{equipmentDetails.Ltd}}
                  </span>
                </div>
              </div>
              <div class="column-container__column">
                <div class="text-block">
                  <span class="text-block__label">
                    {{ Translate('Make') }}
                  </span>
                  <span class="text-block__important">
                    {{equipmentDetails.Make}}
                  </span>
                </div>
                <div class="text-block">
                  <span class="text-block__label">
                    {{ Translate('Model') }}
                  </span>
                  <span class="text-block__important">
                    {{equipmentDetails.Model}}
                  </span>
                </div>
              </div>
              <div class="column-container__column">
                <div class="text-block">
                  <span class="text-block__label">
                    {{ Translate('Family') }}
                  </span>
                  <span class="text-block__important">
                    {{equipmentDetails.Family}}
                  </span>
                </div>
                <div class="text-block">
                  <span class="text-block__label">
                    {{ Translate('Setup Date') }}
                  </span>
                  <span class="text-block__important">
                    {{equipmentDetails.EquipmentSetupDate}}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      
        <div class="ttmodal">
           
        <!--Table View/Edit Temperature-->
        <div class="center" *ngIf="loading || equipmentDetails == null" style="position: absolute;">
            <mat-spinner></mat-spinner>
          </div>
        <div *ngIf="equipmentDetails != null && TemperatureInspectionList !=null" style="width: max-content">
          <tr style="display: flex;">
            <ng-container>
      
              <table style="width: 115px; border-right: outset;">
                <tr class="rowstyle">
                  <span class="cell">{{Translate('Date - Ambient')}}°C </span>
                </tr>
                <tr class="rowstyle">
                  <span class="cell">{{Translate('Inspector')}} </span>
                </tr>
                <tr class="rowstyle">
                  <span class="cell">{{Translate('SMU')}}</span>
                </tr>
                <tr class="rowstyle" style="height: 56px;">
                  <span class="cell"></span>
                </tr>
                <tr class="rowstyle">
                  <span class="cell">{{Translate('Number')}}</span>
                </tr>
      
                <ng-container *ngFor="let inspection of TemperatureInspectionList[0].LeftInspectionDetails">
                  <tr class="rowstyle" style="height: 54px;">
                    <span class="cell">{{inspection.PinNo}}</span>
                  </tr>
                </ng-container>
              </table>
              <i (click)="LoadRecent()" *ngIf="!loadmoreRecent && showArrows" class="material-icons" style="font-size: 65px; width: 40px;    cursor: pointer">
                  arrow_back_ios
                  </i>
            </ng-container>
      
      
      
            <ng-container *ngFor="let inspection of TemperatureInspectionList">
      
              <td>
                <table>
                  <tr class="rowstyle"
                    [class.selectedInspection]="CheckSelectedInspection(inspection.InspectionSummary.InspectionID)">
                    <span class="cell  {{getEval(inspection.InspectionSummary.Eval)}}">
                      <i class="material-icons">
                        fiber_manual_record
                      </i>
                    </span>
                    <span class="cell" style="cursor: pointer;" (click)="OpenDateAmbientChangeDialog(inspection.InspectionSummary.InspectionID,inspection.InspectionSummary.InspectionDate,inspection.InspectionSummary.AmbientTem)">{{inspection.InspectionSummary.InspectionDate |date }} -
                      {{inspection.InspectionSummary.AmbientTem == null? '-':inspection.InspectionSummary.AmbientTem}}°C
                    </span>
                  </tr>
                  <tr class="rowstyle"
                    [class.selectedInspection]="CheckSelectedInspection(inspection.InspectionSummary.InspectionID)">
                    <span class="cell">{{inspection.InspectionSummary.Inspector | aesDecrypt}}</span>
                  </tr>
                  <tr class="rowstyle"
                    [class.selectedInspection]="CheckSelectedInspection(inspection.InspectionSummary.InspectionID)">
                    <span class="cell">{{inspection.InspectionSummary.SMU}}</span>
                  </tr>
      
                  <tr class="rowstyle">
                    <div class="add-data" style="margin-right: 45px;margin-left: 10px;" [class.has-data]="true">
                        <a target="_blank" href="/api/TemperatureInspection/GetTemperatureInspectionPDF?inspectionId={{inspection.InspectionSummary.InspectionID}}">
                      <i title="Generate Report" class="material-icons">picture_as_pdf</i>
                      </a>
                    </div>
                    <div class="add-data" style="margin-right: 45px;"
                      [class.has-data]="HasComment(inspection.InspectionSummary.InspectionID)">
                      <i title="Add/View Comment" class="material-icons" (click)="UpdateInspectionComment(inspection.InspectionSummary.InspectionID,inspection.InspectionSummary.Note,true)">comment</i>
                    </div>
                    <div class="add-data" style="margin-right: 45px;">
                      <!-- <i title="Add/View Image" class="material-icons">camera_alt</i> -->
                      <upload-photo *ngIf="inspection.InspectionSummary.InspectionImage == ''" (onPhotoUpload)="loadTemperatureInspection()" [inspectionId]="inspection.InspectionSummary.InspectionID" [isTempInspection]=true></upload-photo>
                      <img (click)="viewInspectionPhoto(inspection.InspectionSummary.InspectionID,inspection.InspectionSummary.InspectionImage,true)" class="inspection-component-photo__photo" [src]="getImage_(inspection.InspectionSummary.InspectionImage)" *ngIf="inspection.InspectionSummary.InspectionImage != ''" />
                      
                    </div>
                    <div class="add-warning" style="margin-right: 10px;"
                      [class.has-value]="HasWarning(inspection.InspectionSummary.InspectionID)">
                      <i title="{{ getWarning(inspection.InspectionSummary.InspectionID) }}"
                        class="material-icons">warning</i>
                    </div>
                  </tr>
                  <tr class="rowstyle">
                    <div style="display: flex; flex-direction: row; justify-content: space-around;">
                      <div style="border-right: solid; width: 50%; height: 33px;">
                        <span class="cell"> {{Translate('Left')}}</span>
                      </div>
                      <div style=" width: 50%;">
                        <span class="cell">{{Translate('Right')}}</span>
                      </div>
                    </div>
                  </tr>
                  <tr class="rowstyle">
                    <div style="display: flex; flex-direction: row; justify-content: space-around;">
                      <div style="border-right: solid; width: 50%;"
                        [class.chainReplace]="inspection.InspectionSummary.IsChainLReplace">
                        <ng-container *ngFor="let LInfo of inspection.LeftInspectionDetails">
                          <div style="display: flex; flex-direction: row; justify-content: space-around; min-height: 54px; max-height: 54px;">
                            <div style="margin-top: 5%; width: 25%;">
                              <tr>
                                <span class="cell">
                                    <click-to-edit  [major]="IsMajor(LInfo.Outlier)" [minor]="IsMinor(LInfo.Outlier)" [editable]="isInspector" [data]="LInfo.temperature" 
                                    (dataChanged)="updateTemperatureValue($event, LInfo.InspectionDetailId,LInfo.InspectionId)"  [alignRight]="true">
                                      </click-to-edit> 
                                </span>
                              </tr>
                            </div>
                            <div style="width: 61%;">
                              <tr>
                                <div class="add-data" id="LInfo.InspectionDetailId" [class.has-data]="HasDetailComment(LInfo.InspectionId,LInfo.InspectionDetailId,1)">
                                  <i title="Add/View Comment" class="material-icons" (click)="UpdateInspectionDetailComment(LInfo.InspectionDetailId,LInfo.Comment,true)">comment</i>
                                </div>
                                <div class="add-data">
                                  <!-- <i title="Add/View Image" class="material-icons">camera_alt</i> -->
                                  <upload-photo *ngIf="LInfo.Image == ''" (onPhotoUpload)="loadTemperatureInspection()" [inspectionDetailId]="LInfo.InspectionDetailId" [isTempInspectionDetail]=true></upload-photo>
                                  <img style="width: 35px;" (click)="viewInspectionDetailPhoto(LInfo.InspectionDetailId,LInfo.Image,true)" class="inspection-component-photo__photo" [src]="getImage_(LInfo.Image)" *ngIf="LInfo.Image !=''" />
                                          
                                </div>
      
                              </tr>
                            </div>
                          </div>
                        </ng-container>
                      </div>
      
                      <div style="width: 50%;" [class.chainReplace]="inspection.InspectionSummary.IsChainRReplace">
                        <ng-container *ngFor="let RInfo of inspection.RightInspectionDetails">
                          <div style="display: flex; flex-direction: row; justify-content: space-around;min-height: 54px; max-height: 54px;">
                            <div style="margin-top: 5%; width: 25%;">
                              <tr>
                                <span class="cell">
                                    <click-to-edit  [major]="IsMajor(RInfo.Outlier)" [minor]="IsMinor(RInfo.Outlier)" [editable]="isInspector" [data]="RInfo.temperature" 
                                    (dataChanged)="updateTemperatureValue($event, RInfo.InspectionDetailId,RInfo.InspectionId)"   [alignRight]="true">
                                      </click-to-edit> 
                                </span>
                              </tr>
                            </div>
                            <div style="width: 61%;">
                              <tr>
                                <div class="add-data"id="RInfo.InspectionDetailId" [class.has-data]="HasDetailComment(RInfo.InspectionId,RInfo.InspectionDetailId,2)">
                                  <i title="Add/View Comment" class="material-icons" (click)="UpdateInspectionDetailComment(RInfo.InspectionDetailId,RInfo.Comment,true)">comment</i>
                                </div>
                                <div class="add-data" >
                                    <upload-photo *ngIf="RInfo.Image == ''" (onPhotoUpload)="loadTemperatureInspection()" [inspectionDetailId]="RInfo.InspectionDetailId" [isTempInspectionDetail]=true></upload-photo>
                                    <img style="width: 35px;" (click)="viewInspectionDetailPhoto(RInfo.InspectionDetailId,RInfo.Image,true)" class="inspection-component-photo__photo" [src]="getImage_(RInfo.Image)" *ngIf="RInfo.Image != ''" />
                                    
                                </div>
      
                              </tr>
                            </div>
                          </div>
                        </ng-container>
                      </div>
      
      
      </div>
      </tr>
      
      </table>
      </td>
      </ng-container>
      <i (click)="LoadPrvious()" *ngIf="!loadmoreBefore && showArrows" class="material-icons" style="font-size: 65px; width: 40px;    cursor: pointer">
          arrow_forward_ios
          </i>
      </tr>
      
      </div>
      </div>
      
      </div>
</div>
